// Radio Options
export const COMMON = {
    YES: 'Yes',
    NO: 'No',
    NONE: 'None',
    PRODUCTION: 'Production',
    SANDBOX_PERSONAL: 'Sandbox/Personal',
    DEFAULT: 'Default',
    CUSTOM: 'Custom',
};

export const ONBOARDING_CATEGORY = {
    NEW: 'New',
    MIGRATE: 'Migrate',
};

export const MIGRATE_EXISTING_OPTION = {
    ADO: 'ADO',
    GITHUB: 'GITHUB',
};

export const TEAM_TYPE = {
    DEFAULT: 'default',
    CUSTOM: 'custom',
};

// Radio Fields Description Labels
export const ONBOARDING_MIGRATE_DESCRIPTION = 'Do you want to Migrate existing Repository?';
export const ONBOARDING_NEW_DESCRIPTION = 'Do you want to Onboard New GitHub Repository?';
export const IS_USING_AZURE_BOARDS_DESCRIPTION = 'Do You Use Azure Boards for your project planning or backlog tracking?';
export const MIGRATE_ADO_PIPELINES_TO_GITHUB_DESCRIPTION = 'Do you want to migrate ADO Pipelines to GitHub Actions?';
export const MIGRATE_ARGOCD_CONFIG_DESCRIPTION = 'Do you have an ArgoCD configuration repository to migrate?';
export const ARGOCD_CONFIG_REPO_SUFFIX = '-argocd-configs';
export const argoCDConfigColumns = [
    { key: 'adoArgoCDRepoName', label: 'ADO ArgoCD Repository Name' },
    { key: 'newGithubArgoCDRepoName', label: 'New GitHub ArgoCD Repository Name' },
];
export const ONBOARD_GITHUB_ACTIONS_PIPELINES_DESCRIPTION = 'Do you want to onboard GitHub Actions Pipelines for your new repositories?';
export const PIPELINE_SETUP_TYPE_DESCRIPTION = 'What type of pipeline would you like to set up?';
export const PIPELINE_RUN_ONCE_NOTE =
    'Ensure the pipeline has run successfully at least once from the default branch in Azure DevOps. Only the pipeline from the default branch will be migrated to GitHub Actions.';
export const PIPELINE_SETUP_TYPE = {
    BUILD: 'Build',
    BUILD_AND_DEPLOYMENT: 'Build and Deployment',
};
export const MIGRATE_ADO_TO_GITHUB_DESCRIPTION = 'Migration from existing ADO to GitHub Enterprise Repository*';
export const MIGRATE_GITHUB_TO_GITHUB_ENTERPRISE_DESCRIPTION = 'Migration from existing GitHub to GitHub Enterprise Repository*';

// constant values
export const REPO_ACCESS_CONTROL_DEFAULT_TEAM_NAME = 'GitHub Repositories access for Developers & DevOps teams';
export const GITHUB_ORGANIZATION = 'Global-SnT';
export const GITHUB_ORGANIZATION_NEW = 'PepsiCoIT-Actions-Archived';

export const JFROG_ARTIFACTORY_ONBOARDING_URL = 'https://devx-launchpad.mypepsico.com/service-catalogue/jfrogArtifactoryOnboarding';
export const SONAR_ONBOARDING_URL = 'https://devx-launchpad.mypepsico.com/service-catalogue/sonarQubeOnboarding';
export const SERVICE_NOW_REQUEST_URL =
    'https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_category_view.do%3Fv%3D1%26sysparm_parent%3D5688c0290f511700fa1b1b1e51050eab%26sysparm_ck%3D30cbf197c324c750863b7badc001317f49648c6da42d3249bd3e21d66adf9bb6dc5aa8d2%26sysparm_view%3Dcatalog_default%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_default';

export const CWW_AD_GROUP_NAME = 'team.app.github.global.cwwuser';
export const CORP_PVT_GROUP_NAME = 'team.app.github.global.corpuser';
export const CWW_TEMP_AD_GROUP_NAME = 'Team.App.AMESA.NonProd.adsfa32';
export const CORP_PVT_TEMP_AD_GROUP_NAME = 'Team.App.AMESA.NonProd.a0fv9';

export const CORP_EXISTING_MEMBERS_KEY = 'githubADGroupCORPPVTExistingMembers';
export const CWW_EXISTING_MEMBERS_KEY = 'githubADGroupCWWExistingMembers';
export const CORP_REMOVE_EXISTING_MEMBERS_KEY = 'removedGithubADGroupCORPPVTMembers';
export const CWW_REMOVE_EXISTING_MEMBERS_KEY = 'removedGithubADGroupCWWMembers';

export const CORP_ADD_MEMBERS_KEY = 'githubADGroupCORPPVTMembers';
export const CWW_ADD_MEMBERS_KEY = 'githubADGroupCWWMembers';

export const CWW_DOMAIN = 'cww';
export const CORP_PVT_DOMAIN = 'corppvt';

export const AD_GROUP_CONFIG = [
    { key: 'CORP', groupName: CORP_PVT_GROUP_NAME, membersKey: CORP_ADD_MEMBERS_KEY, domain: CORP_PVT_DOMAIN, supportsServiceAccount: true },
    { key: 'CWW', groupName: CWW_AD_GROUP_NAME, membersKey: CWW_ADD_MEMBERS_KEY, domain: CWW_DOMAIN },
];

export const CORP_HAS_SERVICE_ACCOUNT_KEY = 'githubADGroupCORPPVTHasServiceAccount';
export const CORP_SERVICE_ACCOUNTS_KEY = 'githubADGroupCORPPVTServiceAccounts';
export const HAS_AD_GROUP_SERVICE_ACCOUNT_DESCRIPTION = 'Do you require a Service Account?';
export const AD_GROUP_SERVICE_ACCOUNT_SEARCH_PROMPT = 'Type a service account id (must start with svc*) and press Enter or click the search icon to validate.';
export const AD_GROUP_SERVICE_ACCOUNT_INVALID_MSG =
    'The entered service account is not part of Azure Active Directory. Please provide a different service account.';
export const DUPLICATE_AD_GROUP_SERVICE_ACCOUNT_MSG = 'Selected service account has already been added.';

export const TEAM_SUFFIX_DEVELOPERS = 'developers';
export const TEAM_SUFFIX_DEVOPS = 'devops';
export const TEAM_SUFFIX_READER = 'readers';

export const MAX_TEAM_MEMBERS = 6;
export const MAX_DEVOPS_TEAM_MEMBERS = 5;
export const SERVICE_ACCOUNT_EMAIL = 'svcGitHubEnt@pepsico.com';
export const MAX_CUSTOM_TEAMS = 5;
export const MAX_SONAR_MEMBERS = 15;

export const MIGRATION_SUMMARY_TITLE = 'ADO to GitHub Migration Summary';
export const ONBOARDING_SUMMARY_TITLE = 'GitHub Repository Onboarding Summary';
export const MIGRATION_SUMMARY_HEADER_TITLE = 'Migration Status - Summary';
export const ONBOARDING_SUMMARY_HEADER_TITLE = 'Onboarding Status - Summary';

export const HELPER_TEXT_EDIT_AND_CUSTOM_NAME = 'Use only lowercase letters, numbers, and hyphens (never at start or end)';
export const HELPER_TEXT_REPO_NAME = 'Must be 3-99 characters. Use only lowercase letters, numbers, hyphens, or dots (never at start or end)';
export const MICROSERVICE_NAME_HELPER_TEXT = 'Must be 3-62 characters. Use only lowercase letters, numbers, hyphens, or dots (never at start or end).';
export const HELPER_TEXT_SONAR_PROJECT_NAME = 'Must be 2-100 characters. Use lowercase letters, numbers, hyphens, and underscores (never at start or end)';

export const HAS_SERVICE_ACCOUNT_DESCRIPTION = 'Do you have Service Account?';
export const USE_EXISTING_SERVICE_ACCOUNT_DESCRIPTION = 'Do you want to make use of the existing service account?';
export const SONAR_GROUP_SERVICE_ACCOUNT_SEARCH_PROMPT = 'Please select a service account (must start with svc*).';
export const SONAR_GROUP_SERVICE_ACCOUNT_INVALID_MSG =
    'The selected service account is not part of Azure Active Directory. Please select a different service account.';
export const INVALID_SERVICE_ACCOUNT_ERROR =
    'Service account detected is not valid. Please provide a valid service account or select No to create a new service account.';
export const HAS_JFROG_ARTIFACTORY_DESCRIPTION = 'Do you have a JFrog Artifactory Repository Name?';

// JFrog dependency management options
export const JFROG_DEPENDENCY_OPTION_DESCRIPTION = 'How do you plan to utilize JFrog Artifactory for dependency management?';
export const JFROG_DEPENDENCY_OPTION = {
    PUBLIC_ONLY: 'publicOnly',
    PUBLIC_AND_LOCAL: 'publicAndLocal',
};

export const JFROG_REPO_TYPE = {
    RESOLVE: 'virtual',
    UPLOAD: 'local',
};

export const JFROG_REPO_TYPE_LABELS = {
    virtual: 'JFROG RESOLVE REPO',
    local: 'JFROG UPLOAD REPO',
};

export const JFROG_OPTION2_NO_REPO_NOTE =
    'Since you selected Option 2 (public and local repositories) but chose "No" for repository creation, you must create the repository URL from the tooltip section. Alternatively, if you select "No" for "Do you require JFrog Artifactory Repository Integration for your project?", you can proceed with order submission or preview to continue with subsequent steps.';

export const CATALOG_OF_SERVICES_SUB_TITLE = 'Select services that are required for your project';
export const USER_ACCESS_MANAGEMENT_TEAMS_CHECKBOX_LABEL = 'Team name exists in the Organization. Do you want to proceed adding members further?';
export const CONFIRM_DIALOG_REMOVE_GROUP_MEMBERS_MSG = 'Are you sure you want to remove this member from the group?';
export const CONFIRM_DIALOG_REMOVE_AD_GROUP_SERVICE_ACCOUNT_MSG = 'Are you sure you want to remove this service account from the group?';
export const CONFIRM_DIALOG_REMOVE_GROUP_MEMBERS_CONSENT_MSG = 'I have reviewed the affected Teams and confirm to proceed with member removal from this group.';
export const CONFIRM_DIALOG_REVIEW_TEAMS_MSG = 'Before removing, please review and ensure the teams this user is part of:';
export const USER_ACCESS_MANAGEMENT_DEV_TEAM_FORMAT_MSG = 'capabilityName-appname-developers';
export const USER_ACCESS_MANAGEMENT_DEVOPS_TEAM_FORMAT_MSG = 'capabilityName-appname-devops';
export const USER_ACCESS_MANAGEMENT_READER_TEAM_FORMAT_MSG = 'capabilityName-appname-readers';
export const READER_TEAM_REQUIRED_DESCRIPTION = 'Do you want read only team?';

// Alert, Notes Messages
export const MIGRATE_APP_REPO_ADO_ALERT_MSG =
    'After migration existing ADO Repositories will be in read only mode and developers should proceed in the newely created GitHub Enterprise Repositories for further development.';

export const MIGRATE_APP_REPO_GITHUB_ALERT_MSG =
    'After migration existing GitHub Repositories will be in read only mode and developers should proceed in the newely created GitHub Enterprise Repositories for further development.';

export const MIGRATE_APPLICATION_REPO_NOTE = 'Please select repositories to migrate';

export const USER_ACCESS_MANAGEMENT_NOTE =
    "Note: During migration, two default GitHub Teams will be created for repository access control: one ending with '-developers' and another with '-devops'. If you need additional custom teams, click the 'Custom Teams' button highlighted below.";

export const USER_ACCESS_MANAGEMENT_TEAMS_ALERT_MSG =
    'Note: During migration, two default GitHub teams will be created automatically for repository access management:';
export const USER_ACCESS_MANAGEMENT_CUSTOM_TEAMS_ALERT_MSG = 'To create additional teams, click "Add new custom team" below.';
export const USER_ACCESS_MANAGEMENT_TEAMS_ACCESS_RESTRICTION_MSG =
    'Note: The Developers team is granted write access, while the DevOps team is granted repository admin access. The DevOps team is limited to a maximum of five members.';
export const USER_ACCESS_MANAGEMENT_COPILOT_LICENSE_ALERT_MSG =
    'Note: GitHub Enterprise licenses cost $13.71 per unique user per month and are charged once per user. A user may be associated with multiple cost center codes; the license cost is allocated to the currently designated primary cost center code.';

export const MAX_MEMBER_REACHED_MSG = `Limit reached: A team can have only ${MAX_TEAM_MEMBERS} members.`;
export const MAX_DEVOPS_MEMBER_REACHED_MSG = `Limit reached: A DevOps team can have only ${MAX_DEVOPS_TEAM_MEMBERS} members.`;
export const MAX_CUSTOM_TEAM_REACHED_MSG = `Limit reached: You can add only ${MAX_CUSTOM_TEAMS} custom teams.`;
export const TEAM_MEMBER_EXIST_MSG = 'Selected member is already part of another team and cannot be added again.';
export const DUPLICATE_TEAM_NAME_MSG =
    'The system has identified duplicate team names in your configuration. To maintain data integrity and prevent operational conflicts, each team must be assigned a unique name. Please review and update any duplicate entries before continuing.';

export const CONFIRM_DIALOG_USER_NOT_IN_TEAMS_MSG =
    'Selected member is not part of any teams across the organization. Clicking remove will remove this member from the group.';
export const GITHUB_NEW_REPO_CREATION_ALERT_MSG =
    'Note: You may use an existing repository template based on your tech stack by selecting the appropriate language, build tool, and framework. To proceed without a template, select None.';
export const EMAIL_MISSING_ERROR_MSG =
    'Selected member does not have a valid email address in the system. Please contact support or select a different member.';
export const INVALID_DOMAIN_ERROR_MSG = 'Unable to determine the domain type for the selected member. Please contact support or try a different member.';
export const NOT_IN_AD_GROUP_NO_LICENSE_ERROR_MSG =
    'The selected user is not part of the base GitHub AD group. Please add the user in the AD Group Membership section before adding them to teams. If the user is revoked from the Copilot AD group later, they will not be able to access GitHub unless they are part of the base GitHub AD group.';
export const NON_ONBOARDED_REPOS_MIGRATION_VALIDATION_MSG =
    'During validation, our system found that the following selected repositories are not onboarded to SonarQube. Please onboard them first before proceeding further.';
export const NON_ONBOARDED_REPOS_NEW_ONBOARDING_VALIDATION_MSG =
    'During validation, our system found that the following selected repositories are not onboarded to SonarQube. Please provide the service account details below, and we will onboard them for you as part of this request.';
export const PARTIAL_ONBOARDED_REPOS_VALIDATION_MSG =
    'During validation, we found that the following repositories are not onboarded in SonarQube. We will onboard them for you as part of this request.';
export const SONARQUBE_PROJECT_VALIDATION_ALERT_MSG =
    'Validation successful! All selected repositories are already available in SonarQube. You can proceed further.';
// Other
export const INFO_DESCRIPTION = {
    ONBOARDING_CATEGORY_MIGRATE_INFO: 'Do you want to migrate existing ADO repositories ?',
    ONBOARDING_CATEGORY_NEW_INFO: 'Do you want to onboard new repositories to GitHub Enterprise ?',
    HAS_AZURE_BOARDS: "If you don't have any ADO Project, please create new one.",
    HAS_SERVICE_ACCOUNT: "If you don't have a service account, one will be created for you.",
    GITHUB_REPOSITORY_NAME: 'Enter the repository name associated with the selected GitHub organization.',
    PROVISIONING_HEADER:
        'GitHub Enterprise Enablement feature implies both GitHub Repository Onboarding and ADO/GitHub Repository Migration to GitHub Enterprise.',
};

export const CODE_REPOSITORY_STACK_TOOLTIP =
    'Please specify the purpose of your repository (e.g., Infrastructure-as-Code (IaC), Terraform, Ansible, CloudFormation, Pulumi, etc.)';

export const commonTableColumns = [
    { key: 'gpid', label: 'GPID' },
    { key: 'name', label: 'Full Name' },
    { key: 'email', label: 'Email ID' },
];

export const tableColumns = [
    { key: 'name', label: 'Name' },
    { key: 'gpid', label: 'GPID' },
    { key: 'email', label: 'Email' },
];

export const existingMembersTableColumns = [
    { key: 'name', label: 'Name' },
    { key: 'gpid', label: 'GPID' },
    { key: 'email', label: 'Email' },
    { key: 'hasCopilotLicense', label: 'Copilot License' },
];

export const adGroupServiceAccountTableColumns = [{ key: 'serviceAccount', label: 'Service Account' }];

export const previewInfoSectionList = [
    {
        title: 'Project Section',
        sectionName: 'project',
    },
];

export const repoMigrateColumnsAdo = [
    { key: 'adoName', label: 'ADO Repository Name' },
    { key: 'githubName', label: 'New GitHub Repository Name' },
];

export const repoMigrateColumnsGithub = [
    { key: 'githubName', label: 'GitHub Repository Name' },
    { key: 'githubEnterpriseName', label: 'GitHub Enterprise Name' },
];

export const assignAdoRepoColumns = [{ key: 'repo', label: 'GitHub Repository Name' }];
export const assignGithubRepoColumns = [{ key: 'repo', label: 'GitHub Enterprise Name' }];
export const sonarQubeNonOnboardedReposTableColumns = [{ key: 'repositoryName', label: 'Repository Name' }];
export const sonarQubeOnboardedReposTableColumns = [{ key: 'repositoryName', label: 'Repository Name' }];
export const sonarQubeModifyProjectTableColumns = [
    { key: 'githubRepositoryName', label: 'GitHub Repository Name' },
    { key: 'sonarQubeProjectKey', label: 'SonarQube Project Key' },
];

export const LabelMap = {
    applicationType: 'Application Type',
    templateLanguage: 'Language',
    templateBuildTool: 'Build Tool',
    templateFrameWork: 'FrameWork',
    templateName: 'Template Name',
    applicationMicroserviceName: 'Application Microservice Name',
    codeRepositoryStack: 'Code Repository Stack',
};

export const PIPELINE_FIELD_LABELS = {
    pipelineSetup: 'Pipeline Setup',
    pipelineType: 'Pipeline Type',
    selectedTechStack: 'Tech Stack',
    deployMechanism: 'Deploy Mechanism',
    branchingStrategy: 'Branching Strategy',
    buildPattern: 'Build Pattern',
    globalTemplate: 'Global Template',
    deploymentPattern: 'Deployment Pattern',
};

export const PIPELINE_FIELDS = ['pipelineType', 'deployMechanism', 'branchingStrategy'];

export const PIPELINE_TYPE_GLOBAL_TEMPLATE = 'GLOBAL_TEMPLATE';

export default {};
